type SplitFilePath = {
  basename: string;
  directory: string;
};

/** A path's file name and its directory, which ends in a slash; a root file's directory is empty. */
export function splitFilePath(filename: string): SplitFilePath {
  const slashIndex = filename.lastIndexOf('/');
  const basename = slashIndex === -1 ? filename : filename.slice(slashIndex + 1);
  const directory = slashIndex === -1 ? '' : filename.slice(0, slashIndex + 1);

  return {
    basename: basename || filename,
    directory,
  };
}
